module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dof-cell",
    staticClass: " weex-ct weex-div",
    class: ['wrapper', _vm.hasMargin && 'cell-margin'],
    style: (_vm._px2rem(_vm.cellStyleComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['cell-wrapper', _vm.disabled ? 'cell-disabled-opacity' : 'cell-abled-opacity'],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-cell', _vm.hackMrgb1pxcom && 'mgb-1', !_vm.disabled && _vm.isHighlight && 'dof-cell-highlight'],
    style: (_vm._px2rem(_vm.borderStyleComp, 75)),
    attrs: {
      "accessible": _vm.autoAccessible,
      "aria-label": (_vm.label + "," + _vm.title + "," + _vm.desc),
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }, [_vm._t("default", [(_vm.avatarIcon || _vm.avatarIconFont) ? _c('div', {
    staticClass: "left img-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.avatarIcon) ? _c('div', {
    staticClass: "img-container circle-bg weex-ct weex-div",
    class: [_vm.badgeNum && 'Dotright32'],
    style: (_vm._px2rem(_vm.avatarIconBgSizeComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("leftImg", [_c('figure', {
    staticClass: "left-img weex-el weex-image",
    style: (_vm._px2rem(_vm.avatarIconSizeComp, 75)),
    attrs: {
      "src": _vm.avatarIcon,
      "data-img-src": _vm.avatarIcon,
      "weex-type": "image"
    }
  })], {})], 2) : _vm._e(), _vm._v(" "), (_vm.avatarIconFont) ? _c('div', {
    staticClass: "circle-bg weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("leftIconFont", [_c('dof-iconfont', {
    attrs: {
      "code": _vm.avatarIconFont,
      "size": _vm.avatarIconFontSize,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#1E2E37'
    }
  })], {})], 2) : _vm._e(), _vm._v(" "), (_vm.hasDot) ? _c('div', {
    staticClass: "dot-tip weex-ct weex-div",
    class: [_vm.badgeNum && 'dotRight', _vm.dotTipTop],
    style: (_vm._px2rem(_vm.badgeStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }) : (_vm.badgeNum) ? _c('div', {
    staticClass: "dot-num-tip weex-ct weex-div",
    style: (_vm._px2rem(_vm.badgeStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "dot-num-tip-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.dotNum))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['main-container', _vm.hasVerticalIndent && 'cell-indent', _vm.badgeNum && 'notDot'],
    style: (_vm._px2rem(_vm.subBorderStyleComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("label", [(_vm.label) ? _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "cell-label-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textColorComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()], {}), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['middle', _vm.desc ? 'has-desc' : 'no-desc'],
    style: (_vm._px2rem(_vm.innerCellHeightComp, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("middle", [_c('div', {
    staticClass: "cell-title-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['cell-title-content', !_vm.tag && 'title-flex-expand'],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['cell-title'],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    class: ['cell-title-text', !_vm.hasTextTip && 'title-flex-expand'],
    style: (_vm._processExclusiveStyle(_vm.titleStyleComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.hasTextTip) ? _c('div', {
    staticClass: "text-dot-tip weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._t("tag", [(_vm.tag) ? _c('div', {
    staticClass: "cell-title-tag weex-ct weex-div",
    style: ({
      backgroundColor: _vm.iconColor ? _vm.iconColor : _vm._isDiablo ? '#2b2f32' : '#F6F7F9'
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "cell-title-tag-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.tag))])]) : _vm._e()], {})], 2), _vm._v(" "), (_vm.desc) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['cell-desc-wrapper', !_vm.tag && !_vm._isColmo && 'margin-top-24'],
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("desc", [_c('div', {
    staticClass: "cell-desc weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "cell-desc-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.descStyleComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.desc))])])], {})], 2) : _vm._e()], {})], 2), _vm._v(" "), _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['right', _vm.rightTip && 'has-no-padding-left'],
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("rightText", [(_vm.rightText) ? _c('div', {
    staticClass: "right-text-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    class: [
      'right-text',
      !_vm.avatarIcon && 'single-line-text',
      _vm.avatarIcon && _vm.iconSize === 'big' && 'normal-right-text'
    ],
    style: (_vm._processExclusiveStyle(_vm.rightTextStyleComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.rightText))])]) : _vm._e()], {}), _vm._v(" "), (_vm.extraContent) ? _c('p', {
    staticClass: "extra-content-text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textColorComp, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.extraContent))]) : _vm._e(), _vm._v(" "), _vm._t("switch", null, {}), _vm._v(" "), (_vm.hasArrow) ? _c('div', {
    staticClass: "arrow-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("arrow", [(_vm._isColmo) ? _c('dof-iconfont', {
    staticStyle: {
      "width": "0.45333rem"
    },
    attrs: {
      "code": '\u4713',
      "size": 48,
      "color": 'rgba(255,255,255,0.80)',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.onClick
    }
  }) : _c('figure', {
    staticClass: "cell-arrow-icon weex-el weex-image",
    attrs: {
      "src": _vm.arrowIcon,
      "aria-hidden": true,
      "data-img-src": _vm.arrowIcon,
      "weex-type": "image"
    }
  })], {})], 2) : _vm._e()], 2)], 2), _vm._v(" "), (_vm.rightTip) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: [
      'right-tip-wrapper',
      _vm.hasTopSubBorder && 'cell-top-border',
      _vm.hasSubBottomBorder && 'cell-bottom-border',
      _vm.special && 'space-gap'
    ],
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("rightTip", [_c('p', {
    staticClass: "right-tip-text weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.dofRightTipClicked($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.rightTip))])], {})], 2) : _vm._e()], {})], 2)]), _vm._v(" "), (_vm.useFakeBorder) ? _c('div', {
    staticClass: "fake-border weex-ct weex-div",
    style: (_vm._px2rem(_vm.fakeBorderStyleRender, 75)),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-722c555d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722c555d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-cell/index.vue
// module id = 638
// module chunks = 0 1